import { uploadStore, UploadItem } from '../uploads/store'

export function initializeUploadToaster() {
  // Create container if not exists
  let container = document.getElementById('upload-toaster-container')
  if (!container) {
    container = document.createElement('div')
    container.id = 'upload-toaster-container'
    container.className = 'fixed bottom-4 right-4 z-50 flex flex-col gap-2 w-80 max-h-[80vh] overflow-y-auto'
    document.body.appendChild(container)
  }

  // Subscribe to store changes
  uploadStore.subscribe((items) => {
    if (!container) return
    container.innerHTML = '' // distinct re-render for simplicity

    if (items.length === 0) return

    // Header (Optional: "3 uploads in progress")
    const activeCount = items.filter(i => i.status !== 'complete' && i.status !== 'error').length
    if (activeCount > 1) {
      const summary = document.createElement('div')
      summary.className = 'bg-gray-800 text-white text-xs px-3 py-1 rounded-t-md shadow-lg w-fit ml-auto mb-[-4px] relative z-10'
      summary.textContent = `${activeCount} active uploads`
      container.appendChild(summary)
    }

    items.forEach(item => {
      const el = createToastElement(item)
      container!.appendChild(el)
    })
  })
}

function createToastElement(item: UploadItem): HTMLElement {
  const div = document.createElement('div')
  div.className = 'bg-white border border-gray-200 shadow-lg rounded-lg p-3 flex flex-col gap-2 transition-all animate-in slide-in-from-bottom-2 fade-in duration-300'
  
  // Icon based on status
  let icon = ''
  let statusColor = 'bg-blue-600'
  
  if (item.status === 'processing') statusColor = 'bg-purple-500'
  if (item.status === 'complete') {
    statusColor = 'bg-green-500'
    icon = `<svg class="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path></svg>`
  }
  if (item.status === 'error') {
    statusColor = 'bg-red-500'
    icon = `<svg class="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>`
  }

  // Progress Bar Width
  const progressWidth = `${item.progress}%`

  div.innerHTML = `
    <div class="flex items-center justify-between">
      <div class="flex items-center gap-2 overflow-hidden">
        ${icon ? icon : `<div class="w-4 h-4 spinner-border border-2 rounded-full animate-spin border-t-transparent ${item.status === 'error' ? 'border-red-500' : 'border-blue-500'}"></div>`}
        <span class="text-sm font-medium text-gray-700 truncate" title="${item.fileName}">${item.fileName}</span>
      </div>
      <button class="text-gray-400 hover:text-gray-600 focus:outline-none" data-id="${item.id}">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
      </button>
    </div>
    
    <div class="flex flex-col gap-1">
      <div class="w-full bg-gray-100 rounded-full h-1.5">
        <div class="h-1.5 rounded-full ${statusColor} transition-all duration-300" style="width: ${progressWidth}"></div>
      </div>
      <div class="flex justify-between text-xs text-gray-500">
        <span class="truncate max-w-[180px]">${item.message || item.status}</span>
        <span>${Math.round(item.progress)}%</span>
      </div>
    </div>
  `

  // Close Button Logic
  const closeBtn = div.querySelector('button')
  closeBtn?.addEventListener('click', () => {
    uploadStore.removeItem(item.id)
  })

  // Auto-remove completed items after 5 seconds
  if (item.status === 'complete') {
    setTimeout(() => {
      // Check if it still exists before trying to remove to avoid state mismatch
      const current = uploadStore.getItems().find(i => i.id === item.id)
      if (current) uploadStore.removeItem(item.id)
    }, 5000)
  }

  return div
}